var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Html } from "@react-three/drei";
import React, { useCallback } from "react";
// TODO: THIS STYLESHEET SHOULD BE COMMENTED OUT AND THE FILE IMPORTED WITHIN PROJECT-DIGI-CREATOR -
// UNTIL CDN TO HOST/SERVE CSS FILES IS IN PLACE
// import "./VtHtmlHotspotViewerMesh.css";
import { VTHTMLHotspot } from "./VTHTMLHotspot";
export var VTHTMLHotspotViewerMesh = React.forwardRef(function (props, ref) {
    var position = props.position, onHTMLDivContainerRefChange = props.onHTMLDivContainerRefChange, _a = props.transform, transform = _a === void 0 ? false : _a, _b = props.scale, scale = _b === void 0 ? 8 : _b;
    var onHTMLContainerRefChange = useCallback(function (refNode) {
        if (refNode === null) {
            // DOM refNode referenced by ref has been unmounted
        }
        else {
            // DOM refNode referenced by ref has changed and exists
            onHTMLDivContainerRefChange && onHTMLDivContainerRefChange(refNode);
            // mesh.geometry.computeBoundingBox();
        }
    }, []); // adjust deps
    return (_jsx("mesh", __assign({ ref: ref, position: position }, { children: _jsx(Html, __assign({ wrapperClass: "vt-html-hotspot-viewer", ref: onHTMLContainerRefChange, transform: transform, scale: scale, center: true, as: "div", 
            // fullscreen
            zIndexRange: [0, 1] }, { children: _jsx(VTHTMLHotspot, __assign({}, props)) })) })));
});
